import { CellType, LetterApprovalCellDefinition } from '@/components/dataTables/cell'

export const LetterApprovalHeader: LetterApprovalCellDefinition = {
  align: 'center',
  width: 200,
  filterable: true,
  sortable: false,
  type: CellType.letterApproval,
}
